import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Constant } from '../../shared/constant/constant';
import { SubscriptionPackagesAdminService } from './SubscriptionPackagesAdminService';
// import { SubscriptionPackagesService } from 'src/app/pages/setup/subscription-settings/subscription-packages/subscription-packages.service';
import { SnackService } from '../../shared/components/snack/snack.service';
import { SharedDialogComponent } from '../../shared/components/shared-dialog/shared-dialog.component';
import { ConfirmUpdateDialogComponent } from 'src/app/pages/human-resources/customer-employees/employee-dialog/add-assignment-dialog/confirm-update/confirm-update-dialog.component';
import { SubscriptionConfirmComponent } from './subscription-confirm/subscription-confirm.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SearchRequest } from '../../shared/modal/shared/searchCriteria';
import { SubscriptionQuoteDialogComponent } from './SubscriptionQuoteDialog.component';

@Component({
  selector: 'app-subscription-prices-login',
  templateUrl: './subscription-prices-login.component.html',
  styleUrls: ['./subscription-prices-login.component.scss']
})
export class SubscriptionPricesLoginComponent implements OnInit {
  subscriptionPackages = [];
  subscribedPackages = [];
  BRANCH_CONFIG = JSON.parse(localStorage.getItem('BRANCH_CONFIG')) || { country: {} };
  BRANCH_COUNTRY = this.BRANCH_CONFIG.country || {};
  config_lang = JSON.parse(window.localStorage.getItem(`CONFIG_${this._translate.currentLang || 'en'}`)) || {};
  paymentPeriods = this.config_lang.paymentPeriods || [];
  SUB_PERIODS = this.constant.SUB_PERIODS || [];
  paymentDis = this.SUB_PERIODS.length > 0 ? this.SUB_PERIODS[0] : {};
  limitDiscount = 0;
  baseDiscount = 0;
  periodId = 0;
  erbDiscount: number = 0;
  selectedPackages: any[] = [];
  baseSelectedPackages: any[] = [];
  limitPrice = 0;
  statusCode: Object = new Constant().STATUS_CODE;
  basePrice = 0;
  private subscriptions = new Subscription();
  edit = false;
  privilegeUpdated: boolean = false;
  subscriptionsRequests = [];
  subscriptionsRequestsStatus;
  condition = 'mydisable';
  erbPrice: number = 0;
  limitPeriodId = this.SUB_PERIODS.length > 0 ? this.SUB_PERIODS[0].id : 2;
  basePeriodId = this.SUB_PERIODS.length > 0 ? this.SUB_PERIODS[0].id : 2;
  erbPeriodId: number = this.SUB_PERIODS.length > 0 ? this.SUB_PERIODS[0].id : 2;
  currentUser = JSON.parse(localStorage.getItem('CURRENT_USER')) || {};
  
  // Fix for the currency code error - adding null check
  currency = this.BRANCH_CONFIG?.country?.currency?.code || 'SAR';

  // New properties for custom package selection
  isCustomPackage: boolean = false;
  isFull: boolean = false;
  selectedModules: any[] = [];

  constructor(
    public _translate: TranslateService,
    public constant: Constant,
    public dialog: MatDialog,
    public activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private subscriptionPackageService: SubscriptionPackagesAdminService,
    private snack: SnackService
  ) { }

  ngOnInit(): void {
    // Delay initialization to prevent null pointers if data isn't ready
  
      this.initializePackages();
   
  }

  // initializePackages() {
  //   try {
  //     console.log('Initializing packages...');
  //     if (!this.BRANCH_COUNTRY || !this.BRANCH_COUNTRY.id) {
  //       console.error('BRANCH_COUNTRY id is missing');
  //       return;
  //     }

  //     this.subscriptionPackageService.filterCustomerSubscriptionPackages(1).subscribe(
  //       (res) => {
  //         console.log('Subscription packages loaded:', res);
  //         if (res && res.data) {
  //           // Sort packages: regular packages first, then quotation packages
  //           this.subscriptionPackages = res.data.sort((a, b) => {
  //             // If a is a package that requires quotation and b is not, then b comes first
  //             if (a.isRequiredQuotation && !b.isRequiredQuotation) return 1;
  //             // If a is not a package that requires quotation and b is, then a comes first
  //             if (!a.isRequiredQuotation && b.isRequiredQuotation) return -1;
  //             // Otherwise keep original order
  //             return 0;
  //           });

  //           // Ensure each screen has an expanded property and transactions array
  //           this.prepareScreensData();

  //           this.subscribedPackages = this.subscriptionPackages.filter((e) => e.isUsed === true);
  //           if (this.subscribedPackages.length < 1) {
  //             this.edit = true;
  //           } else {
  //             this.selectedPackages.push(...this.subscribedPackages.map((e) => e));
  //             this.baseSelectedPackages.push(...this.subscribedPackages.map((e) => e));
  //           }

  //           if (res.data.length > 0) {
  //             this.limitDiscount = res.data[0].discount || 0;
  //             if (res.data.length > 1) {
  //               this.baseDiscount = res.data[1].discount || 0;
  //               if (res.data.length > 2) {
  //                 this.erbDiscount = res.data[2].discount || 0;
  //               }
  //             }
  //             this.limitPrice = res.data[0].price || 0;
  //             if (res.data.length > 1) {
  //               this.basePrice = res.data[1].price || 0;
  //               if (res.data.length > 2) {
  //                 this.erbPrice = res.data[2].price || 0;
  //               }
  //             }
  //           }

  //           // Initialize custom package settings
  //           this.subscriptionPackages.forEach(pkg => {
  //             if (pkg.isUsed && pkg.isCustomPackage) {
  //               this.isCustomPackage = true;
  //               this.isFull = pkg.isFull || false;
  //               if (!this.isFull && pkg.userModule) {
  //                 pkg.userModule.forEach(module => {
  //                   if (module.selected) {
  //                     this.selectedModules.push({ id: module.id });
  //                   }
  //                 });
  //               }
  //             }
  //           });

  //           // Force change detection to update the view
  //           this.cdr.detectChanges();
  //         }
  //       },
  //       error => {
  //         console.error('Error loading subscription packages:', error);
  //       }
  //     );

  //     this.subscriptionPackageService.getCustomerSubscriptionPackagesRequests().subscribe(
  //       requestsRes => {
  //         console.log('Subscription requests loaded:', requestsRes);
  //         if (requestsRes !== null && requestsRes.data !== null) {
  //           this.subscriptionsRequestsStatus = requestsRes.data.statusCode;
  //           this.subscriptionsRequests = requestsRes.data.packageList || [];
  //           this.privilegeUpdated = requestsRes.data.privilegeUpdated;
  //           if (this.subscriptionsRequestsStatus === 3 && !this.privilegeUpdated) {
  //             this.getCustomerPrivileges();
  //           }

  //           // Force change detection to update the view
  //           this.cdr.detectChanges();
  //         }
  //       },
  //       error => {
  //         console.error('Error loading subscription requests:', error);
  //       }
  //     );
  //   } catch (error) {
  //     console.error('Error in initializePackages:', error);
  //   }
  // }
  initializePackages() {
    try {
      console.log('Initializing packages...');
      
      
      const countryId = this.BRANCH_COUNTRY?.id || 2; 
      if (!countryId) {
        console.error('Country ID is missing, using default value: 1');
      }
  
      
      console.log(`Fetching subscription packages for countryId: ${countryId}`);
  
      this.subscriptionPackageService.filterCustomerSubscriptionPackages(countryId).subscribe(
        (res) => {
          console.log('Subscription packages loaded:', res);
          if (res && res.data) {
            
            this.subscriptionPackages = res.data.sort((a, b) => {
              if (a.isRequiredQuotation && !b.isRequiredQuotation) return 1;
              if (!a.isRequiredQuotation && b.isRequiredQuotation) return -1;
              return 0;
            });
  
            this.prepareScreensData();
            this.subscribedPackages = this.subscriptionPackages.filter((e) => e.isUsed === true);
            if (this.subscribedPackages.length < 1) {
              this.edit = true;
            } else {
              this.selectedPackages.push(...this.subscribedPackages.map((e) => e));
              this.baseSelectedPackages.push(...this.subscribedPackages.map((e) => e));
            }
  
            if (res.data.length > 0) {
              this.limitDiscount = res.data[0].discount || 0;
              this.limitPrice = res.data[0].price || 0;
              if (res.data.length > 1) {
                this.baseDiscount = res.data[1].discount || 0;
                this.basePrice = res.data[1].price || 0;
                if (res.data.length > 2) {
                  this.erbDiscount = res.data[2].discount || 0;
                  this.erbPrice = res.data[2].price || 0;
                }
              }
            }
  
            this.cdr.detectChanges();
          }
        },
        (error) => {
          console.error('Error loading subscription packages:', error);
         
          if (error.status === 401) {
            console.error('Authentication error: API requires login, but it should be public.');
          }
        }
      );
  
      
      if (this.currentUser && Object.keys(this.currentUser).length > 0) {
        this.subscriptionPackageService.getCustomerSubscriptionPackagesRequests().subscribe(
          (requestsRes) => {
            console.log('Subscription requests loaded:', requestsRes);
            if (requestsRes !== null && requestsRes.data !== null) {
              this.subscriptionsRequestsStatus = requestsRes.data.statusCode;
              this.subscriptionsRequests = requestsRes.data.packageList || [];
              this.privilegeUpdated = requestsRes.data.privilegeUpdated;
              if (this.subscriptionsRequestsStatus === 3 && !this.privilegeUpdated) {
                this.getCustomerPrivileges();
              }
              this.cdr.detectChanges();
            }
          },
          (error) => {
            console.error('Error loading subscription requests:', error);
          }
        );
      } else {
        console.log('User not logged in, skipping subscription requests.');
      }
    } catch (error) {
      console.error('Error in initializePackages:', error);
    }
  }

  /**
   * Prepares the screens data by ensuring each screen has an expanded property
   * and transactions array initialized
   */
  prepareScreensData() {
    if (!this.subscriptionPackages) return;

    // Define actual transactions for all modules using the exact same translation keys from components
    const allTransactions = {
      // Finance module transactions
      'Finance Setting': [
        {
          transactionId: 1,
          name: 'SETUP_HOME.BANK_ACCOUNTS',
          details: 'SETUP_HOME.INV_TRANS.BANK_ACCOUNTS_DESCRIPTION',
          fontIcon: 'account_balance',
          url: '/pages/finance/finance-setups',
        },
        {
          transactionId: 2,
          name: 'SETUP_HOME.INV_TRANS.BRANCH_ACCOUNTS',
          details: 'SETUP_HOME.INV_TRANS.BRANCH_ACCOUNTS_DETAILS',
          fontIcon: 'signal_cellular_alt',
          url: '/pages/finance/branch-accounts',
        },
        {
          transactionId: 3,
          name: 'SETUP_HOME.INV_TRANS.COST_CENTER_NAME',
          details: 'SETUP_HOME.INV_TRANS.COST_CENTER_DESCRIPTION',
          fontIcon: 'pie_chart',
          url: '/pages/finance/general-listing',
        },
        {
          transactionId: 4,
          name: 'SETUP_HOME.ASSETS_CATEGORY',
          details: 'SETUP_HOME.ASSETS_CATEGORY_DESC',
          fontIcon: 'border_all',
          url: '/pages/finance/asset-category-list',
        },
        {
          transactionId: 5,
          name: 'SETUP_HOME.RATE_MANAGEMENT',
          details: 'SETUP_HOME.RATE_MANAGEMENT_DESC',
          fontIcon: 'currency_exchange',
          url: '/pages/finance/rate-management',
        },
        {
          transactionId: 6,
          name: 'SETUP_HOME.ZAKAT_INVOICE',
          details: 'SETUP_HOME.ZAKAT_INVOICE_DESC',
          fontIcon: 'text_snippet',
          url: '/pages/finance/setup-zakat',
        },
        {
          transactionId: 7,
          name: 'SETUP_HOME.FIXED_ASSETS',
          details: 'SETUP_HOME.FIXED_ASSETS_DESC',
          fontIcon: 'settings',
          url: '/pages/finance/fixed-assets-list',
        },
      ],
      'Finance Transaction': [
        {
          transactionId: 1,
          name: 'SETUP_HOME.INV_TRANS.PAYABLE_INVOICE',
          details: 'SETUP_HOME.INV_TRANS.PAYABLE_INVOICE_DETAILS',
          fontIcon: 'receipt',
          url: '/pages/finance/payable-invoice',
        },
        {
          transactionId: 2,
          name: 'SETUP_HOME.INV_TRANS.JOURNALS',
          details: 'SETUP_HOME.INV_TRANS.JOURNALS_DETAILS',
          fontIcon: 'receipt_long',
          url: '/pages/finance/journal',
        },
        {
          transactionId: 3,
          name: 'CASH_TRANSFER.TITLE',
          details: 'SETUP_HOME.CASH_TRANSFER_DESC',
          fontIcon: 'payments',
          url: '/pages/finance/cash-transfer',
        },
        {
          transactionId: 4,
          name: 'CUSTOMER_INVOICES.TITLE',
          details: 'SETUP_HOME.CASH_TRANSFER_DESC',
          fontIcon: 'receipt_long',
          url: '/pages/customer-invoices/list',
        },
        {
          transactionId: 5,
          name: 'PERIOD_MANAGEMENT.TITLE',
          details: 'PERIOD_MANAGEMENT.DESC',
          fontIcon: 'date_range',
          url: '/pages/finance/period-management',
        },
        {
          transactionId: 6,
          name: 'SETUP_HOME.INV_TRANS.FIXED_ASSETS',
          details: 'SETUP_HOME.INV_TRANS.FIXED_ASSETS_DESC',
          fontIcon: 'pie_chart',
          url: '/pages/finance/fixed-assets-list',
        },
      ],
      // 'Chart of Account': [
      //   {
      //     transactionId: 1,
      //     name: 'SETUP_HOME.INV_TRANS.CHART_ACCOUNTS',
      //     details: 'FINANCE.CHART_OF_ACCOUNTS.DESCRIPTION',
      //     fontIcon: 'account_tree',
      //     url: '/pages/finance/chart-of-account'
      //   }
      // ],

      // Inventory Setup transactions with properly localized keys
      'Inventory Setup': [
        {
          transactionId: 1,
          name: 'SETUP_HOME.CATEGORY_AND_SUBCATEGORY',
          details: 'SETUP_HOME.CATEGORY_AND_SUBCATEGORY_DETAILS',
          fontIcon: 'widgets',
          url: '/pages/product/view-all-products'
        },
        {
          transactionId: 2,
          name: 'SETUP_HOME.BROWSE_YOUR_ITEMS',
          details: 'SETUP_HOME.BROWSE_YOUR_ITEMS_DETAILS',
          fontIcon: 'edit_note',
          url: '/pages/category'
        },
        {
          transactionId: 3,
          name: 'SETUP_HOME.SUPPLIERS',
          details: 'SETUP_HOME.SUPPLIERS_DESCRIPTION',
          fontIcon: 'local_shipping',
          url: '/pages/store'
        },
        {
          transactionId: 4,
          name: 'SETUP_HOME.BRANDS',
          details: 'SETUP_HOME.BRANDS_DETAILS',
          fontIcon: 'local_offer',
          url: '/pages/units'
        },
        // {
        //   transactionId: 5,
        //   name: 'BRAND.TITLE',
        //   details: 'SETUP_HOME.BRANDS_DETAILS',
        //   fontIcon: 'branding_watermark',
        //   url: '/pages/brands'
        // },


      ],

      // HR module transactions
      'HR Transaction': [
        {
          transactionId: 1,
          name: 'HR.EMPLOYEES',
          details: 'HR.EMPLOYEES_DETAILS',
          fontIcon: 'recent_actors',
          url: '/pages/hr/customer-employees'
        },
        {
          transactionId: 2,
          name: 'COMMON.PRINT_EMP_CARD',
          details: 'HR.PRINT_EMP_CARD_DESC',
          fontIcon: 'badge',
          url: '/pages/hr/print/card'
        },
        {
          transactionId: 3,
          name: 'TIMESHEET.ATTENDANCE_TIMESHEET',
          details: 'HR.TIME_SHEET_DETAILS',
          fontIcon: 'schedule',
          url: '/pages/hr/timesheet-setting'
        },
        {
          transactionId: 4,
          name: 'PAYROLL.TITLE',
          details: 'PAYROLL.PAYROLL_DETAILS',
          fontIcon: 'account_balance_wallet',
          url: '/pages/hr/payroll'
        },
        {
          transactionId: 5,
          name: 'PAYSLIPS.PAYSLIP_LIST',
          details: 'PAYSLIPS.PAYSLIP_DETAILS',
          fontIcon: 'receipt',
          url: '/pages/hr/payslip'
        },
        // {
        //   transactionId: 6,
        //   name: 'TIMESHEET.ATTENDANCE_REPORT',
        //   details: 'HR.ATTENDANCE_REPORT_DESC',
        //   fontIcon: 'assessment',
        //   url: '/pages/hr/attendance-report'
        // }
      ],

      // Human Resources Management transactions with properly localized keys
      ' Human Resource Management': [
        {
          transactionId: 1,
          name: 'HR.DEPARTMENTS',
          details: 'HR.DEPARTMENTS_DETAILS',
          fontIcon: 'business',
          url: '/pages/hr/departments',
        },
        {
          transactionId: 2,
          name: 'HR.JOBS',
          details: 'HR.JOBS_DETAILS',
          fontIcon: 'business_center',
          url: '/pages/hr/jobs',
        },
        {
          transactionId: 3,
          name: 'HR.POSITIONS',
          details: 'HR.POSITIONS_DETAILS',
          fontIcon: 'badge',
          url: '/pages/hr/positions-setting',
        },
        {
          transactionId: 4,
          name: 'HR.ANNOUNCEMENTG',
          details: 'HR.ANNOUNCEMENTG_DETAILS',
          fontIcon: 'campaign',
          url: '/pages/hr/AnnouncementListing',
        },
        {
          transactionId: 5,
          name: 'HR.PAYROLL_ELEMENT',
          details: 'HR.PAYROLL_ELEMENT_DETAILS',
          fontIcon: 'credit_card',
          url: '/pages/hr/PayrollElementListing',
        },
        {
          transactionId: 6,
          name: 'HR.PERFORMANCE_PLANS',
          details: 'HR.PERFORMANCE_PLANS_DETAILS',
          fontIcon: 'speed',
          url: '/pages/hr/PlansListComponent',
        },
        {
          transactionId: 7,
          name: 'HR.Learning_plans',
          details: 'HR.Learning_plans_Details',
          fontIcon: 'school',
          url: '/pages/hr/learningPlansList',
        },
        {
          transactionId: 8,
          name: 'HR.REQUESTS_VACATIONS',
          details: 'HR.REQUESTS_VACATIONS_DESCRIPTION',
          fontIcon: 'beach_access',
          url: '/pages/hr/self-services',
        },
        {
          transactionId: 9,
          name: 'COMMON.PUBLIC_HOLIDAYS',
          details: 'COMMON.PUBLIC_HOLIDAYS_DESC',
          fontIcon: 'pending_actions',
          url: '/pages/shopping-customer/calendar-exception',
        },
        {
          transactionId: 10,
          name: 'COMMON.WORKFLOW',
          details: 'COMMON.WORKFLOW_DESC',
          fontIcon: 'account_tree',
          url: '/pages/hr/work-flow',
        },
        {
          transactionId: 11,
          name: 'COMMON.Organizational_Hierarchy',
          details: 'COMMON.Organizational_Hierarchy_DESC',
          fontIcon: 'device_hub',
          url: '/pages/hr/organization-hierarchy',
        },
      ],

      // Inventory module transactions
      'Inventory Transaction': [
        {
          transactionId: 1,
          name: 'SETUP_HOME.SEARCH_YOUR_PRODUCTS',
          details: 'SETUP_HOME.SEARCH_PRODUCTS',
          fontIcon: 'query_stats',
          url: '/pages/shopping-customer/customer-product'
        },
        {
          transactionId: 2,
          name: 'SETUP_HOME.INV_TRANS.RECEVING',
          details: 'SETUP_HOME.INV_TRANS.RECEVING_DETAILS',
          fontIcon: 'local_shipping',
          url: '/pages/inventory-receiving/view-inventory-receiving'
        },
        {
          transactionId: 3,
          name: 'SETUP_HOME.INV_TRANS.COUNTING-ORDER',
          details: 'SETUP_HOME.INV_TRANS.COUNTING-ORDER_DETAILS',
          fontIcon: 'checklist',
          url: '/pages/inventory/counting-order'
        },
        {
          transactionId: 4,
          name: 'SETUP_HOME.INV_TRANS.TRANSFER',
          details: 'SETUP_HOME.INV_TRANS.TRANSFER_DETAILS',
          fontIcon: 'compare_arrows',
          url: '/pages/inventory-transfer/view-inventory-transfer'
        },
        // {
        //   transactionId: 5,
        //   name: 'SETUP_HOME.RETURN_ITEMS',
        //   details: 'SETUP_HOME.RETURN_ITEMS_DESC',
        //   fontIcon: 'assignment_return',
        //   url: '/pages/inventory/returns'
        // },
        // {
        //   transactionId: 6,
        //   name: 'SETUP_HOME.INVENTORY_REPORT',
        //   details: 'SETUP_HOME.INVENTORY_REPORT_DESC',
        //   fontIcon: 'assessment',
        //   url: '/pages/inventory/report'
        // }
      ],

      // Point of Sale transactions
      'Point of Sale': [
        {
          transactionId: 1,
          name: 'POS.TITLE',
          details: 'POS.DESCRIPTION',
          fontIcon: 'point_of_sale',
          url: '/pages/pos/start-session'
        },
        {
          transactionId: 2,
          name: 'POS.SESSIONS',
          details: 'POS.SESSIONS_DESC',
          fontIcon: 'history',
          url: '/pages/pos/sessions'
        },
        {
          transactionId: 3,
          name: 'POS.SETTINGS',
          details: 'POS.SETTINGS_DESC',
          fontIcon: 'settings',
          url: '/pages/pos/settings'
        }
      ],

      // Customer Invoices transactions
      'Customer Invoices': [
        {
          transactionId: 1,
          name: 'INVOICE.TITLE',
          details: 'CUSTOMER_INVOICES.INVOICE_DESC',
          fontIcon: 'receipt',
          url: '/pages/customer-invoices/customer-invoices-list'
        },
        {
          transactionId: 2,
          name: 'INVOICE.RECURRING',
          details: 'CUSTOMER_INVOICES.RECURRING_DESC',
          fontIcon: 'repeat',
          url: '/pages/customer-invoices/recurring-invoices'
        }
      ],

      // Customer Management transactions with properly localized keys
      'Customer Management': [
        {
          transactionId: 1,
          name: 'CUSTOMER.CUSTOMERS',
          details: 'CUSTOMER.CUSTOMERS_DESC',
          fontIcon: 'people',
          url: '/pages/customers'
        },
        {
          transactionId: 2,
          name: 'CUSTOMER.CUSTOMER_GROUPS',
          details: 'CUSTOMER.CUSTOMER_GROUPS_DESC',
          fontIcon: 'group_work',
          url: '/pages/customer-groups'
        },
        {
          transactionId: 3,
          name: 'CUSTOMER.LOYALTY',
          details: 'CUSTOMER.LOYALTY_DESC',
          fontIcon: 'loyalty',
          url: '/pages/customer-loyalty'
        },
        {
          transactionId: 4,
          name: 'CUSTOMER.CRM',
          details: 'LOGIN_SERVICE.CRM_DESC',
          fontIcon: 'contact_phone',
          url: '/pages/crm'
        }
      ],

      // Supplier Management transactions with properly localized keys
      'Supplier Management': [
        {
          transactionId: 1,
          name: 'SUPPLIERS.SUPPLIERS',
          details: 'SETUP_HOME.SUPPLIERS_DESCRIPTION',
          fontIcon: 'business',
          url: '/pages/suppliers'
        },
        {
          transactionId: 2,
          name: 'SUPPLIERS.SUPPLIER_GROUPS',
          details: 'SUPPLIERS.SUPPLIER_GROUPS_DESC',
          fontIcon: 'account_tree',
          url: '/pages/supplier-groups'
        }
      ],

      // Reporting & Analytics transactions with properly localized keys
      'Reporting & Analytics': [
        {
          transactionId: 1,
          name: 'REPORTS.SALES_REPORT',
          details: 'SALES.SALES_DETAILS',
          fontIcon: 'bar_chart',
          url: '/pages/reports/sales'
        },
        {
          transactionId: 2,
          name: 'REPORTS.INVENTORY_REPORT',
          details: 'SETUP_HOME.INVENTORY_REPORT_DESC',
          fontIcon: 'analytics',
          url: '/pages/reports/inventory'
        },
        {
          transactionId: 3,
          name: 'REPORTS.FINANCIAL_REPORT',
          details: 'FINANCE.FINANCE_DETAILS',
          fontIcon: 'insert_chart',
          url: '/pages/reports/financial'
        },
        {
          transactionId: 4,
          name: 'REPORTS.DASHBOARD',
          details: 'REPORTS.DASHBOARD_DESC',
          fontIcon: 'dashboard',
          url: '/pages/reports/dashboard'
        }
      ]
    };


    this.subscriptionPackages.forEach(pkg => {
      if (pkg.userModule) {
        pkg.userModule.forEach(module => {
          if (module.screens) {
            module.screens.forEach(screen => {
              screen.expanded = false;
              if (!screen.transactions) {
                const normalizedScreenName = screen.name.toLowerCase().trim();
                const matchingKey = Object.keys(allTransactions).find(key =>
                  key.toLowerCase().trim() === normalizedScreenName
                );
                if (matchingKey) {
                  screen.transactions = [...allTransactions[matchingKey]];
                  screen.hasTransactions = true;
                } else {
                  screen.hasTransactions = false;
                }
              }
            });
          }
        });
      }
    });
  }

  getStatus(value) {
    return Object.keys(this.statusCode).find(key => this.statusCode[key] === value);
  }

  // New method to open quote request dialog
  openQuoteRequestDialog(packageName?: string, isRequiredQuotation?: boolean, isCustomPackage?: boolean) {
    const dialogRef = this.dialog.open(SubscriptionQuoteDialogComponent, {
      width: '500px',
      data: {
        packageName: packageName,
        isRequiredQuotation: isRequiredQuotation,
        isCustomPackage: isCustomPackage
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Refresh data if needed after successful quote request
        this.initializePackages();
      }
    });
  }

  choosePackage(billingPackageId) {
    const dialogRef = this.dialog.open(SubscriptionConfirmComponent);
    dialogRef.afterClosed().subscribe((res) => {
      if (res === true) {
        this.updateSelectedPackages(billingPackageId);
      } else {
        this.snack.showSnack('SUBSCRIPTION_SETTINGS.SUBSCRIPTION_CANCELED', 'warning');
      }
    });
  }

  updateSelectedPackages(billingPackageId) {
    if (billingPackageId === 2) {
      this.periodId = this.limitPeriodId;
    }
    if (billingPackageId === 3) {
      this.periodId = this.basePeriodId;
    }
    if (billingPackageId === 4) {
      this.periodId = this.erbPeriodId;
    }

    let index = this.selectedPackages.findIndex((p) => p.billingPackageId === billingPackageId);
    if (index >= 0) {
      this.selectedPackages = this.selectedPackages.filter((p) => p.billingPackageId !== billingPackageId);

      // Reset custom package settings if no packages are selected
      if (this.selectedPackages.length === 0) {
        this.isCustomPackage = false;
        this.isFull = false;
        this.selectedModules = [];
      }
    } else {
      const selectedPackage = this.subscriptionPackages.find((p) => p.billingPackageId === billingPackageId);
      if (selectedPackage) {
        this.selectedPackages.push(selectedPackage);

        // Check if this is a custom package
        if (selectedPackage.isCustomPackage) {
          this.isCustomPackage = true;
          this.isFull = false;
          this.selectedModules = [];
        } else {
          this.isCustomPackage = false;
          this.isFull = false;
          this.selectedModules = [];
        }
      }
    }
  }

  submitPackagesSelection() {
    if (this.selectedPackages.length === 0) {
      this.snack.showSnack('SUBSCRIPTION_SETTINGS.SELECT_PACKAGE', 'warning');
      return;
    }

    const selectedPackage = this.selectedPackages[this.selectedPackages.length - 1];

    let requestBody: any = [{
      billingRulePackageId: selectedPackage.billingPackageId,
      isCustomPackage: this.isCustomPackage,
      isFull: this.isFull,
      modules: []
    }];

    if (this.isCustomPackage && !this.isFull) {
      if (this.selectedModules.length === 0) {
        this.snack.showSnack('SUBSCRIPTION_SETTINGS.SELECT_MODULES', 'warning');
        return;
      }
      requestBody[0].modules = this.selectedModules;
    }

    // Send data to server
    this.subscriptionPackageService.updateCustomerPackage(requestBody, this.periodId).subscribe((res) => {
      if (res.success) {
        this.snack.showSnack(res.data, 'success');
        this.edit = false;
        this.initializePackages();
      }
    });
  }

  isSelected(packageId) {
    if (this.selectedPackages.length) {
      let index = this.selectedPackages.findIndex((p) => p.billingPackageId === packageId);
      return index >= 0;
    }
    return false;
  }

  // New method to directly unselect a package without confirmation dialog
  unselectPackage(billingPackageId) {
    // Remove the package from selected packages
    this.selectedPackages = this.selectedPackages.filter((p) => p.billingPackageId !== billingPackageId);

    // If the unselected package was a custom package, reset custom package settings
    if (this.isCustomPackage) {
      // Check if any other custom packages remain selected
      const remainingCustomPackage = this.selectedPackages.find(pkg => pkg.isCustomPackage);

      if (!remainingCustomPackage) {
        // If no custom packages left, reset custom package state
        this.isCustomPackage = false;
        this.isFull = false;
        this.selectedModules = [];
      }
    }

    // Show a notification
    this.snack.showSnack('SUBSCRIPTION_SETTINGS.PACKAGE_UNSELECTED', 'info');
  }

  enableEdit() {
    this.edit = !this.edit;
    if (this.edit === true) {
      this.snack.showSnack('SUBSCRIPTION_SETTINGS.PACKAGE_SUBSCRIPTION_EDIT', 'success');
    }
  }

  onChangePeriod(event, subPac) {
    let element = this.SUB_PERIODS?.find(period => period.value === event.value);

    if (subPac.id === 2) {
      // limit
      this.limitPeriodId = element.id;
      if (event.value === 'MONTHLY') {
        this.limitDiscount = subPac.discount;
        this.limitPrice = subPac.price;
      }
      if (event.value === 'QUARTERLY') {
        this.limitDiscount = subPac.discount;
      }
      if (event.value === 'SEMI_YEAR') {
        this.limitDiscount = subPac.discount;
      }
      if (event.value === 'YEARLY') {
        this.limitDiscount = subPac.discount;
      }
    }
    if (subPac.id === 3) {
      // base
      this.basePeriodId = element.id;
      if (event.value === 'MONTHLY') {
        this.baseDiscount = subPac.discount;
      }
      if (event.value === 'QUARTERLY') {
        this.baseDiscount = subPac.discount;
      }
      if (event.value === 'SEMI_YEAR') {
        this.baseDiscount = subPac.discount;
      }
      if (event.value === 'YEARLY') {
        this.baseDiscount = subPac.discount;
      }
    }
    if (subPac.id === 4) {
      // erb
      this.erbPeriodId = element.id;
      if (event.value === 'MONTHLY') {
        this.erbDiscount = subPac.discount;
      }
      if (event.value === 'QUARTERLY') {
        this.erbDiscount = subPac.discount;
      }
      if (event.value === 'SEMI_YEAR') {
        this.erbDiscount = subPac.discount;
      }
      if (event.value === 'YEARLY') {
        this.erbDiscount = subPac.discount;
      }
    }
  }

  openMore(translateText) {
    const dialogRef = this.dialog.open(SharedDialogComponent, {
      data: { translateText },
    }).addPanelClass('rounded_dialog');
  }

  arraysEqualIgnoreOrder(arr1: any[], arr2: any[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }

    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;
  }

  getCustomerPrivileges() {
    this.subscriptionPackageService.getUserPrivileges().subscribe((res) => {
      // console.log(res);
    });
  }

  // Methods for custom package selection
  toggleFullPackage() {
    this.isFull = !this.isFull;

    // Find the selected custom package
    const selectedCustomPackage = this.selectedPackages.find(pkg => pkg.isCustomPackage);

    if (this.isFull) {
      // If selecting all, clear individual selections
      this.selectedModules = [];

      // If there is a selected custom package with modules, add all module IDs to selectedModules
      if (selectedCustomPackage && selectedCustomPackage.userModule) {
        // Mark all modules as selected
        selectedCustomPackage.userModule.forEach(module => {
          module.selected = true;
        });
      }
    } else {
      // If deselecting all, clear selections
      this.selectedModules = [];

      // If there is a selected custom package with modules, mark all as unselected
      if (selectedCustomPackage && selectedCustomPackage.userModule) {
        selectedCustomPackage.userModule.forEach(module => {
          module.selected = false;
        });
      }
    }

    // Force change detection to update UI
    this.cdr.detectChanges();
  }

  /**
   * Toggle the expanded state of a screen to show/hide its transactions
   * Only allow expansion if the screen has transactions
   * @param screen The screen object to toggle
   */
  toggleScreen(screen) {
    // Only allow toggling if screen has transactions
    if (!screen.hasTransactions) {
      return; // Don't expand if there are no transactions
    }

    // Initialize expanded property if it doesn't exist
    if (screen.expanded === undefined) {
      screen.expanded = false;
    }

    screen.expanded = !screen.expanded;

    // Force change detection to update UI
    this.cdr.detectChanges();
  }

  toggleModuleSelection(module) {
    const index = this.selectedModules.findIndex(m => m.id === module.id);
    if (index >= 0) {
      this.selectedModules.splice(index, 1);
      module.selected = false;
    } else {
      this.selectedModules.push({ id: module.id });
      module.selected = true;
    }

    // Check if all modules are selected to update isFull accordingly
    const selectedCustomPackage = this.selectedPackages.find(pkg => pkg.isCustomPackage);
    if (selectedCustomPackage && selectedCustomPackage.userModule) {
      const allModules = selectedCustomPackage.userModule.length;
      const selectedCount = this.selectedModules.length;
      this.isFull = (allModules === selectedCount && allModules > 0);
    }
  }

  isModuleSelected(moduleId) {
    return this.selectedModules.some(m => m.id === moduleId);
  }

  // Helper method to get the count of packages to confirm (not already subscribed)
  getPackagesToConfirmCount() {
    if (!this.selectedPackages || this.selectedPackages.length === 0) {
      return 0;
    }
    return this.selectedPackages.filter(pkg => !pkg.isUsed).length;
  }

  // Generate tooltip text with names of selected packages
  getSelectedPackagesTooltip() {
    if (!this.selectedPackages || this.selectedPackages.length === 0) {
      return '';
    }

    // Filter out packages that are already subscribed (don't need confirmation)
    const packagesToConfirm = this.selectedPackages.filter(pkg => !pkg.isUsed);

    if (packagesToConfirm.length === 0) {
      return this._translate.instant('SUBSCRIPTION_SETTINGS.NO_CHANGES');
    }

    // Join package names with line breaks for tooltip display
    return packagesToConfirm.map(pkg => pkg.name).join('\n');
  }

  expandAllScreens(module: any): void {
    if (module.screens) {
      const allExpanded = module.screens.every(screen => screen.expanded);
      module.screens.forEach(screen => {
        screen.expanded = !allExpanded;
      });
    }
  }
}